export enum MessageType {
  Info = 'info',
  Success = 'success',
  Danger = 'danger'
}
